import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CloseIcon = (props: IconProps) => (
  <Icon width="28px" height="28px" viewBox="0 0 28 28" {...props}>
    <path d="m22.167 7.479-1.645-1.646L14 12.355 7.478 5.833 5.833 7.48 12.355 14l-6.522 6.522 1.645 1.645L14 15.645l6.522 6.522 1.645-1.645L15.645 14l6.522-6.521Z" />
  </Icon>
);

export default memo(CloseIcon);
